import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CheckboxChangeEventDetail, IonInput, LoadingController, ModalController } from '@ionic/angular';
import { GlobalConstants } from 'src/app/constant/constant';

@Component({
  selector: 'app-ion-select-searchable',
  templateUrl: './ionSelectSearchable.component.html',
  styleUrls: ['./ionSelectSearchable.component.scss'],
})
export class IonSelectSearchableComponent implements OnInit, OnDestroy {
  @Input() multiple = false;
  @Input() value: any;
  @Input() displayProperty: string;
  @Input() showSearchBoxCountGreaterThan?: number;
  @ViewChild('searchTextBox') searchTextBox: IonInput;
  searchText: string = '';
  filteredArray: any;
  selectedValue: any[] = [];
  private loadingCtrl: HTMLIonLoadingElement;
  private delayTimer;
  constructor(private modalController: ModalController, private loadingController: LoadingController) {}
  ngOnDestroy(): void {
    this.filteredArray = undefined;
  }

  ngOnInit(): void {
    this.filteredArray = this.value;
    if (this.value.length > GlobalConstants.SEARCH_LIST_ITEM_LIMIT) {
      this.value = this.filteredArray.slice(0, GlobalConstants.SEARCH_LIST_ITEM_LIMIT);
    }
  }

  ionViewDidEnter() {
    setTimeout(_ => {
      if (this.searchTextBox) {
        this.searchTextBox.setFocus();
      }
    }, 200);
  }

  onChange(event) {
    this.searchText = event.target.value;
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      const filteration = this.searchText;
      this.value = this.filterItems(filteration);
      if (filteration.length === 0) {
        if (this.filteredArray.length > GlobalConstants.SEARCH_LIST_ITEM_LIMIT) {
          this.value = this.filteredArray.slice(0, GlobalConstants.SEARCH_LIST_ITEM_LIMIT);
        } else {
          this.value = this.filteredArray;
        }
      }
    }, 1000);
  }

  filterItems(searchTerm) {
    //console.log(`filteredArray.length: ${this.filteredArray.length}`);
    return this.filteredArray.filter(item => item[this.displayProperty].toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
  }

  onMultipleSelect(event: Event) {
    const customEvent = event as CustomEvent<CheckboxChangeEventDetail>;
    const checked = customEvent.detail.checked;
    if (checked) {
      this.selectedValue.push(customEvent.detail.value);
    } else {
      this.selectedValue = this.selectedValue.filter(item => item !== customEvent.detail.value);
    }
  }

  onSingleSelect(data) {
    this.selectedValue = [data];
    this.onDone();
  }

  getIdName(index, description) {
    return description.substring(0, 6) + index;
  }

  private async presentLoading(message: string) {
    this.loadingCtrl = await this.loadingController.create({
      //cssClass: 'my-custom-class',
      message,
      //duration: 2000
      spinner: 'lines',
    });
    await this.loadingCtrl.present();
    this.loadingCtrl.onDidDismiss().then(data => {
      //console.log('popup dismissed');
      //console.log(data);
    });
    return Promise.resolve();
  }

  async onClose() {
    await this.modalController.dismiss();
  }

  async onDone() {
    if (this.multiple) {
      await this.submitData(this.selectedValue);
    } else {
      await this.submitData(this.selectedValue[0]);
    }
  }

  private async submitData(data) {
    if (this.filteredArray.length <= 500) {
      return await this.modalController.dismiss(data);
    } else {
      await this.presentLoading(undefined);
      await this.modalController.dismiss(data);
      this.loadingController.dismiss();
    }
  }
}
